/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useState } from 'react';

// Create the context
export const HeaderContext = createContext();

// Create the provider component
export default function HeaderProvider({ children }) {
  const [headerData, setHeaderData] = useState({
    headerTitle: 'Home',
    headerBreadCrumb: '',
    headerBreadCrumbClickable: '',
  });
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [userRedirectPage, setUserRedirectPage] = useState('');
  const [profileImage, setProfileImage] = useState('');
  const [unVerifiedField, setUnverifiedField] = useState('');
  const [showLogin, setShowLogin] = useState(false);

  return (
    <HeaderContext.Provider value={{
      headerData,
      setHeaderData,
      showProfilePopup,
      setShowProfilePopup,
      userRedirectPage,
      setUserRedirectPage,
      showLogoutPopup,
      setShowLogoutPopup,
      profileImage,
      setProfileImage,
      unVerifiedField,
      setUnverifiedField,
      showLogin,
      setShowLogin,
    }}
    >
      {children}
    </HeaderContext.Provider>
  );
}
